import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from './../app.breadcrumb.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../../core/_services/core.services';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  cargandoPagina: boolean = false;
  datos: any;
  fecha_perfilamiento: any;
  fecha_experiencia: any;
  fecha_estudio: any;
  fecha_referencias: any;
  fecha_grupo_familiar: any;
  fecha_competencias: any;
  fecha_habilidades: any;
  fecha_conocimientos: any;
  fecha_redes_sociales: any;
  experiencias: number = 0;
  estudio: number = 0;
  personal: number = 0;
  familiar: number = 0;
  competencia: number = 0;
  habilidades: number = 0;
  conocimientos: number = 0;
  redessociales: number = 0;
  perfilamiento: number = 0;
  datosbasicos: number = 0;
  nombres: any;
  listaImagenes: any[] = [];

  imagenes: any[]

  username: String = sessionStorage.getItem('username');
  nombre: any;

  constructor(
    private breadcrumbService: AppBreadcrumbService,
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.setItems([
      { label: 'Inicio' }
    ]);
    this.imagenes = [
      {
        src: 'assets/img/Campana_Fraude_Blanco_2.jpg',
        alt: 'Fraude Blanco'
      },
      {
        src: 'assets/img/Campana_Fraude_V1_2.png',
        alt: 'fraude-blanco-v1'
      },
      {
        src: 'assets/img/Pruebas-COVID-19_2.png',
        alt: 'pruebas-covid'
      }
    ];
    this.cargarImagenes();
    this.usuarioConectado();
    this.cargarDatos();
    this.spinner.hide();

  }
  usuarioConectado() {
    let params = {}
    this.coreService.post('/user-info', params).subscribe(
      (res: any) => {
        this.nombre = res.name.toLowerCase();
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  cargarDatos() {
    this.coreService.get('/datos-inicio').subscribe(
      (res: any) => {

        this.experiencias = res.experiencias;
        this.familiar = res.familiares;
        this.estudio = res.estudios;
        this.personal = res.personales;
        this.competencia = res.competencias;
        this.habilidades = res.habilidades;
        this.conocimientos = res.conocimientos;
        this.redessociales = res.redessociales;
        this.perfilamiento = res.perfilamiento;
        this.datosbasicos = res.datosbasicos;
        this.datos = (res.datos === undefined || res.datos === null) ? null :res.datos.updated_at;
        this.fecha_perfilamiento = (res.fecha_perfilamiento === undefined || res.fecha_perfilamiento === null) ? null :res.fecha_perfilamiento.updated_at;
        this.fecha_experiencia = (res.fecha_experiencias === undefined || res.fecha_experiencias === null) ? null :res.fecha_experiencias.updated_at;
        this.fecha_estudio = (res.fecha_estudio === undefined || res.fecha_estudio === null) ? null :res.fecha_estudio.updated_at;
        this.fecha_referencias = (res.fecha_personal === undefined || res.fecha_personal === null) ? null :res.fecha_personal.updated_at;
        this.fecha_grupo_familiar = (res.fecha_familiar === undefined || res.fecha_familiar === null) ? null :res.fecha_familiar.updated_at;
        this.fecha_competencias = (res.fecha_competencias === undefined || res.fecha_competencias === null) ? null :res.fecha_competencias.updated_at; 
        this.fecha_habilidades = (res.fecha_habilidades === undefined || res.fecha_habilidades === null) ? null :res.fecha_habilidades.updated_at; 
        this.fecha_conocimientos = (res.fecha_conocimientos === undefined || res.fecha_conocimientos === null) ? null :res.fecha_conocimientos.updated_at;
        this.fecha_redes_sociales = (res.fecha_redesSociales === undefined || res.fecha_redesSociales === null) ? null :res.fecha_redesSociales.updated_at;

      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  cargarImagenes() {
    this.imagenes.forEach(e => {
      this.listaImagenes.push(e);
    });
  }

  abrirLink(url) {
    window.open(url, '_blank')
  }
}
